module.exports = __webpack_public_path__ + "img/bg1.f64627bb.png";